import { Termin } from '@/domain/termine/shared/types/Termin';
import { TerminWiederholung } from '@/domain/termine/shared/types/TerminWiederholung';
import { buildTerminOccurrence } from '@/domain/termine/shared/utils/buildTerminOccurrence';
import { isDateInZeitraum } from '@/domain/termine/shared/utils/dateValidations';
import {
  intervallMapToDayjsManipulateMap,
  wiederholungMap,
} from '@/domain/termine/shared/utils/individuelleWiederholungenHelper';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { addIndividuellTermin } from '@/domain/termine/shared/utils/addIndividuellTermin';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

// eslint-disable-next-line complexity
export function generateWiederholungen(
  termin: Termin,
  monthStart: dayjs.Dayjs,
  monthEnd: dayjs.Dayjs,
): Termin[] {
  const occurrences: Termin[] = [];
  const start = dayjs(termin.datum);
  const end = termin.wiederholungBis ? dayjs(termin.wiederholungBis) : monthEnd;
  const wiederholungen = wiederholungMap[termin.wiederholung];

  function addTerminIfInZeitraum(date: dayjs.Dayjs) {
    if (
      isDateInZeitraum(date, monthStart, monthEnd) &&
      !date.isBefore(start, 'day') &&
      !date.isAfter(end, 'day')
    ) {
      occurrences.push(buildTerminOccurrence(termin, date));
    }
  }
  const individuell = termin.individuelleWiederholung;

  const iterationUnit =
    individuell && termin.wiederholung === TerminWiederholung.INDIVIDUELL
      ? intervallMapToDayjsManipulateMap[individuell.wiederholungsIntervall]
      : wiederholungen;

  if (!iterationUnit) {
    addTerminIfInZeitraum(start);
    return occurrences;
  }

  let current = start;
  const step =
    individuell && termin.wiederholung === TerminWiederholung.INDIVIDUELL
      ? individuell.occurrenceCount
      : 1;

  while (current.isSameOrBefore(end, 'day')) {
    if (individuell && termin.wiederholung === TerminWiederholung.INDIVIDUELL) {
      addIndividuellTermin(current, individuell, start, addTerminIfInZeitraum);
    } else {
      addTerminIfInZeitraum(current);
    }
    current = current.add(step, iterationUnit);
  }

  return occurrences;
}
